import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Box,
  Tooltip,
} from "@mui/material";
import { Info } from "@mui/icons-material";
import { useTranslation } from "../../../../hooks/useTranslation";
import { ProductDetail } from "../types";
import { Section } from "./Section";

type OtherProps = {
  productDetail?: ProductDetail;
};

export const Other = ({ productDetail }: OtherProps) => {
  const { translate, translateWithoutPrefix } = useTranslation("pages.product");

  return (
    <Section title={translate("other")}>
      <Table size="small">
        <TableBody>
          <TableRow>
            <TableCell>
              <Typography
                variant="body2"
                sx={{ display: "flex", alignItems: "center" }}
              >
                {translate("salesVolume")}
                <Box component="span" sx={{ marginLeft: 1 }}>
                  <Tooltip title={translate("salesVolumeInfo")}>
                    <Info fontSize="small" />
                  </Tooltip>
                </Box>
              </Typography>
            </TableCell>
            <TableCell>
              {productDetail?.marketplaceProduct?.product?.salesVolume ??
                translateWithoutPrefix("common.unknown")}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("brand")}</TableCell>
            <TableCell>
              {productDetail?.marketplaceProduct?.brandName ??
                translateWithoutPrefix("common.unknown")}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("isBestSeller")}</TableCell>
            <TableCell>
              {productDetail?.marketplaceProduct?.product?.bestSeller === true
                ? translateWithoutPrefix("common.yes")
                : productDetail?.marketplaceProduct?.product?.bestSeller ===
                    false
                  ? translateWithoutPrefix("common.no")
                  : translateWithoutPrefix("common.unknown")}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("isAmazonChoice")}</TableCell>
            <TableCell>
              {productDetail?.marketplaceProduct?.product?.amazonsChoice ===
              true
                ? translateWithoutPrefix("common.yes")
                : productDetail?.marketplaceProduct?.product?.amazonsChoice ===
                    false
                  ? translateWithoutPrefix("common.no")
                  : translateWithoutPrefix("common.unknown")}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell>{translate("mainCategorySalesRank")}</TableCell>
            <TableCell>
              {productDetail?.marketplaceProduct?.mainCategorySalesRank ??
                translateWithoutPrefix("common.unknown")}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("subCategorySalesRank")}</TableCell>
            <TableCell>
              {productDetail?.marketplaceProduct?.subCategorySalesRank ??
                translateWithoutPrefix("common.unknown")}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Section>
  );
};
